import PropTypes from 'prop-types';

const ScreenIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g fill={fill}>
        <path d="M42,0 C45.3137085,0 48,2.6862915 48,6 L48,30 C48,33.3137085 45.3137085,36 42,36 L6,36 C2.6862915,36 0,33.3137085 0,30 L0,6 C0,2.6862915 2.6862915,0 6,0 L42,0 Z M40.5,4.5 L7.5,4.5 C5.844,4.5 4.5,5.844 4.5,7.5 L4.5,28.5 C4.5,30.156 5.844,31.5 7.5,31.5 L40.5,31.5 C42.156,31.5 43.5,30.156 43.5,28.5 L43.5,7.5 C43.5,5.844 42.156,4.5 40.5,4.5 Z" />
        <rect x="0" y="39" width="48" height="4.5" rx="0.938" />
      </g>
    </svg>
  </div>
);

ScreenIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

ScreenIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default ScreenIcon;
